export type ExternalArtistMeta = {
  artistName: string
  image?: string
  banner?: string
  description?: string
  instagram?: string
  spotify?: string
  color?: string
}

export const EXTERNAL_ARTISTS: Record<
  string,
  ExternalArtistMeta
> = {
  "amy-moon": {
    artistName: "Amy Moon",
    image: "/image/external-artist/amy-moon.jpg",
    banner: "",
    description: "Cantante de múisca Blues, Pop y Urban.",
    instagram: "https://instagram.com/amy-moon",
    spotify: "https://spotify.com",
    color: "#8B5CF6",
  },

  "young-miko": {
    artistName: "Young Miko",
    image: "/image/external-artist/young-miko.jpg",
    banner: "/image/external-artist/young-miko.jpg",
    description: "Cantante y compositora puertorriqueña.",
    instagram: "https://instagram.com/itsyoungmiko",
    spotify: "https://spotify.com",
    color: "#8B5CF6",
  },

  "myke-towers": {
    artistName: "Myke Towers",
    image: "/image/external-artist/myke-towers.jpg",
    banner: "/image/external-artist/myke-towers.jpg",
    description: "Cantante y compositora puertorriqueña.",
    instagram: "https://instagram.com/itsyoungmiko",
    spotify: "https://spotify.com",
    color: "#8B5CF6",
  },

  "karol-g": {
    artistName: "Karol G",
    image: "/image/external-artist/karol-g.jpg",
    banner: "",
    description: "Cantante y compositora puertorriqueña.",
    instagram: "https://instagram.com/itsyoungmiko",
    spotify: "https://spotify.com",
    color: "#8B5CF6",
  },

  "mora": {
    artistName: "Mora",
    image: "/image/external-artist/mora.jpg",

    description: "Cantante y compositora puertorriqueña.",
    instagram: "https://instagram.com/itsyoungmiko",
    spotify: "https://spotify.com",
    color: "#8B5CF6",
  },

  "feid": {
    artistName: "Feid",
    image: "/image/external-artist/feid.jpg",
    banner: "/image/external-artist/feid.jpg",
    description: "Cantante colombiano.",
    color: "#7CFF00",
  },
}